<template>
  <div>
    <b-modal
      ref="openModal"
      class="selectUser"
      scrollable
      size="xl"
      title="Vincular ao setor"
    >
      <div>
        <h3>{{ $t("user.available") }}</h3>

        <b-table
          class="table-nowrap shLogStatusTrip"
          :items="getAllUser"
          :fields="fieldsAvailable"
          :filter="tableFilters"
          ref="selectableTable"
          :filter-debounce="500"
          :per-page="tablePerPage"
          :current-page="tableCurrentPage"
          @row-clicked="onRowClicked"
        >
          <template slot="thead-top" slot-scope="{ fields }">
            <b-tr>
              <b-th
                v-for="field in fields"
                :key="field.filterKey"
                class="vertical-align"
              >
                <b-form-input
                  v-if="field.filterKey != 'selected'"
                  v-model="tableFilters[field.filterKey]"
                  :placeholder="'Buscar por ' + field.label"
                  class="idStyle"
                />
              </b-th>
            </b-tr>
          </template>
          <template #cell(selected)="data">
            <template v-if="data.item.active">
              <span aria-hidden="true">&check;</span>
              <!-- <span class="sr-only">Selected</span> -->
            </template>
            <template v-else>
              <span aria-hidden="true">&nbsp;</span>
              <span class="sr-only">Not selected</span>
            </template>
          </template>
        </b-table>
        <TablePaginationPropsMini
          :currentPage.sync="tableCurrentPage"
          :pageOptions.sync="tablePageOptions"
          :perPage.sync="tablePerPage"
          :rowCount.sync="tableRowCount"
        >
        </TablePaginationPropsMini>
      </div>

      <div>
        <h3>{{ $t("user.selected") }}</h3>

        <b-table
          ref="tableSelectedItems"
          class="table-nowrap shLogStatusTrip"
          :items="filterSelectedItems"
          :fields="fieldsSelected"
          :filter="tableFiltersSelected"
          @row-clicked="onRowClicked"
        >
          <template slot="thead-top" slot-scope="{ fields }">
            <b-tr>
              <b-th
                v-for="field in fields"
                :key="field.filterKey"
                class="vertical-align"
              >
                <b-form-input
                  v-if="field.filterKey != 'selected'"
                  v-model="tableFiltersSelected[field.filterKey]"
                  :placeholder="'Buscar por ' + field.label"
                  class="idStyle"
                />
              </b-th>
            </b-tr>
          </template>
        </b-table>
      </div>

      <template #modal-footer="{}">
        <div class="right">
          <b-button variant="green" @click="save" :disabled="submitted">
            {{ $t("geral.confirm") }}
          </b-button>
          <b-button class="ml-2" variant="danger" @click="cancel">
            {{ $t("geral.cancel") }}
          </b-button>
        </div>
      </template>

      <!-- {{ selected }} -->
      <!-- <pre class="language-json">
        <code>selected: {{ selected  }}</code>
      </pre> -->
      <!-- <pre class="language-json">
        <code>selectedItems: {{ selectedItems  }}</code>
      </pre> -->
    </b-modal>
  </div>
</template>
<script>
export default {
  name: "SelectedUserModal",
  props: {
    selected: Array,
  },
  components: {
    TablePaginationPropsMini: () =>
      import("@/components_rms/base/TablePaginationPropsMini.vue"),
  },
  data() {
    return {
      submitted: false,
      fieldsAvailable: [
        {
          key: "selected",
          filterKey: "selected",
          sortable: false,
          label: "",
          tdClass: (value, key, item) => this.getTdClass(item),
        },
        {
          key: "presentationName",
          filterKey: "presentationName",
          sortable: false,
          label: "Usuário",
          tdClass: (value, key, item) => this.getTdClass(item),
        },
        {
          key: "profile",
          filterKey: "profile",
          sortable: false,
          label: "Perfil",
          tdClass: (value, key, item) => this.getTdClass(item),
        },
      ],
      fieldsSelected: [
        {
          key: "presentationName",
          filterKey: "presentationName",
          sortable: false,
          label: "Usuário",
          tdClass: "text-success font-weight-bold",
        },
        {
          key: "profile",
          filterKey: "profile",
          sortable: false,
          label: "Perfil",
          tdClass: "text-success font-weight-bold",
        },
      ],
      tableFilters: {
        profile: "",
        presentationName: "",
      },
      tableFiltersSelected: {
        profile: "",
        presentationName: "",
      },
      items: [],
      selectedItems: [],
      tableRowCount: 0,
      tableRowCountSelected: 0,
      tableCurrentPage: 1,
      tableCurrentPageSelected: 1,
      tablePerPage: 10,
      tablePerPageSelected: 10,
      tablePageOptions: [5, 10, 25, 50, 100, 150],
      tableSelectMode: "single",
      tableSelectedItem: [],
    };
  },
  methods: {
    show() {
      this.selectedItems = [];
      this.selected.forEach((currentSelectedItem) => {
        const newSelectedItem = {
          id: currentSelectedItem.id,
          active: currentSelectedItem.active,
          userId: currentSelectedItem.userId,
          profile: currentSelectedItem.profile,
          presentationName: currentSelectedItem.presentationName,
        };
        this.selectedItems.push(newSelectedItem);
      });
      this.$refs.openModal.show();
      this.$forceUpdate();
    },
    onRowClicked(item, index) {
      if (item.active) {
        this.onRowRemove(item);
      } else {
        this.onRowAdd(item);
      }
    },
    onRowAdd(itemToAdd) {
      if (itemToAdd.active) {
        return;
      }
      itemToAdd.active = true;
      this.selectedItems.push(itemToAdd);
      this.$refs.tableSelectedItems.refresh();
    },
    onRowRemove(itemToRemove) {
      let indexToRemove = this.selectedItems.indexOf(itemToRemove);
      this.selectedItems.splice(indexToRemove, 1);
      itemToRemove.active = false;
      this.$refs.tableSelectedItems.refresh();
    },
    filterSelectedItems(ctx, callback) {
      const items = this.selectedItems.filter((item) => {
        return Object.keys(this.tableFiltersSelected).every((key) => {
          return String(item[key])
            .toLowerCase()
            .includes(this.tableFiltersSelected[key].toLowerCase());
        });
      });
      this.tableRowCountSelected = items.length;
      callback(items);
    },
    getAllUser(ctx, callback) {
      let apiParam = {
        currentPage: ctx.currentPage,
        perPage: ctx.perPage,
        profile: ctx.filter.profile,
        presentationName: this.tableFilters.presentationName,
      };
      this.$apiScheduler
        .post("/sector/getAllUsers/", apiParam)
        .then((response) => {
          const items = response.data.items;
          items.forEach((availableItem) => {
            this.selectedItems.forEach((selectedItem) => {
              if (availableItem.userId == selectedItem.userId) {
                availableItem.active = true;
              }
            });
          });
          this.isBusy = false;
          this.tableRowCount = response.data.totalItems;
          callback(items);
        });
    },
    getRowStyle(item) {
      if (item.active) {
        return "color: green";
      }
      return "";
    },
    getTdClass(item) {
      return item.active ? "text-success font-weight-bold" : "";
    },
    save() {
      this.$emit("update:selected", this.selectedItems);
      this.$refs.openModal.hide();
      this.emptyFilters();
    },
    cancel() {
      this.$refs.openModal.hide();
      this.emptyFilters();
    },
    emptyFilters() {
      this.tableFilters.profile = "";
      this.tableFilters.presentationName = "";
    },
  },
};
</script>
